import { useParams } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";

const PHONE = "+90 542 878 64 99";
const WHATSAPP = "905428786499";
const CALL_LABEL = { tr: "Ara", en: "Call", el: "Κλήση", ru: "Позвонить", fa: "تماس" };

export default function MobileContactBar() {
  const { lang } = useParams();
  const call = CALL_LABEL[lang] || CALL_LABEL.en;

  return (
    <div
      data-testid="mobile-contact-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-white/10 bg-obsidian/95 backdrop-blur-md"
    >
      <a
        href={`tel:${PHONE.replace(/\s/g, "")}`}
        data-testid="mobile-call-btn"
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-ink hover:text-copper transition-colors"
      >
        <Phone size={18} /> {call}
      </a>
      <a
        href={`https://wa.me/${WHATSAPP}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-whatsapp-btn"
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-white bg-[#25D366] hover:brightness-110 transition"
      >
        <MessageCircle size={18} /> WhatsApp
      </a>
    </div>
  );
}
